import * as React from 'react';
import Breadcrumbs from '../../Breadcrumbs';
import { Config } from '../helper';

function Progress({ percent }) {
  const value = Math.round(percent || 0);
  return (
    <div className='sidebar-block nv-learning-pathway-progress'>
      <p className='h--smallest'>{Config.I18n.Progress}</p>
      <p className='h--small'>{Config.I18n.Completion(value)}</p>
      <div className='btn-group'>
        <div className='progress'>
          <div
            className='progress-bar'
            role='progressbar'
            style={{ width: `${value}%` }}
            aria-valuenow={value}
            aria-valuemin='0'
            aria-valuemax='100'
          />
        </div>
      </div>
    </div>
  );
}

export default function Header(props) {
  const {
    title = '',
    text = '',
    icon = '',
    progress = 0,
    breadcrumbs = [],
    extraResources = null,
  } = props;

  return (
    <div className='nv-contextual-hero-banner nv-contextual-hero-banner--with-sidebar topic-area nv-learning-pathway-header'>
      <div className='container'>
        <div className='row row-override'>
          <div className='nv-contextual-hero-banner__main'>
            <Breadcrumbs items={breadcrumbs}/>
            <div className='nv-contextual-hero-banner__heading'>
              {icon && <img src={icon} alt='' role='presentation'/>}
              <h1 className='h--large'>{title}</h1>
            </div>

            {text && <p className='p--large mb-3' dangerouslySetInnerHTML={{ __html: text }}/>}
          </div>
          <div className='nv-contextual-hero-banner__sidebar'>
            <Progress percent={progress}/>
            {extraResources}
          </div>
        </div>
      </div>
    </div>
  );
}
